import React from 'react';
import { useTranslation } from 'react-i18next';
import { IdleServiceEntry } from '../types';

interface Props {
  entries: IdleServiceEntry[];
}

const IdleServicesPanel: React.FC<Props> = ({ entries }) => {
  const { t } = useTranslation('admin');

  return (
    <div className="roi-panel idle-panel">
      <h3 className="roi-panel-title">{t('roiInsights.panels.idle')}</h3>

      {entries.length === 0 ? (
        <div className="idle-empty">{t('roiInsights.idle.empty')}</div>
      ) : (
        <table className="roi-stats-table">
          <thead>
            <tr>
              <th>{t('roiInsights.idle.columns.name')}</th>
              <th>{t('roiInsights.idle.columns.idleSince')}</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(entry => (
              <tr key={entry.serviceName}>
                <td>{entry.serviceName}</td>
                <td>{entry.idleSinceLabel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default IdleServicesPanel;
